module.exports = __webpack_public_path__ + "static/img/twjd-sdo14.cbd8916.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdo14.png
// module id = 856
// module chunks = 0